import { Design } from '../../../types';

/** Normalize all @see DesignCsvData objects on a @see Design. */
export function normalizeCsvs(serialized: Design) {
  serialized.csvData ??= [];
  serialized.csvData.forEach((csv) => {
    csv.lastLocalChange ??= 0;
    csv.lastSavedChange ??= 0;
  });
}
